import BaseApi from './base.api'
import ApiUrls from './urls.api'

export default {

    Tags: {

        StandardsBook: {

            PostEdit: function (tagDto, apiHeaders) {
                return BaseApi.post(ApiUrls.Admin.Tags.StandardsBook.PostEdit, tagDto, apiHeaders)
            },

            PostDelete: function (tagId, apiHeaders) {
                return BaseApi.post(`${ApiUrls.Admin.Tags.StandardsBook.PostDelete}?id=${tagId}`, null, apiHeaders)
            },

            PostUpdateSorting: function (tagsDto, apiHeaders) {
                return BaseApi.post(ApiUrls.Admin.Tags.StandardsBook.PostUpdateSorting, tagsDto, apiHeaders)
            },

            GetTag: function (tagId, apiHeaders) {
                return BaseApi.get(`${ApiUrls.Admin.Tags.StandardsBook.GetTag}?id=${tagId}`, null, apiHeaders)
            },

            GetTags: function (apiHeaders) {
                return BaseApi.get(ApiUrls.Admin.Tags.StandardsBook.GetTags, null, apiHeaders)
            },

            GetAllInfo: function (apiHeaders) {
                return BaseApi.get(ApiUrls.Admin.Tags.StandardsBook.GetAllInfo, null, apiHeaders)
            }
        },

        Activities: {

            PostUpdate: function (tagDto, apiHeaders) {
                return BaseApi.post(ApiUrls.Admin.Tags.Activities.PostUpdate, tagDto, apiHeaders)
            },

            PostDelete: function (tagId, apiHeaders) {
                return BaseApi.post(`${ApiUrls.Admin.Tags.Activities.PostDelete}?id=${tagId}`, null, apiHeaders)
            },

            PostUpdateSorting: function (tagsDto, apiHeaders) {
                return BaseApi.post(ApiUrls.Admin.Tags.Activities.PostUpdateSorting, tagsDto, apiHeaders)
            },
            
            GetTag: function (tagId, apiHeaders) {
                return BaseApi.get(`${ApiUrls.Admin.Tags.Activities.GetTag}?id=${tagId}`, null, apiHeaders)
            },

            GetTags: function (apiHeaders) {
                return BaseApi.get(ApiUrls.Admin.Tags.Activities.GetTags, null, apiHeaders)
            },

            GetAllInfo: function (apiHeaders) {
                return BaseApi.get(ApiUrls.Admin.Tags.Activities.GetAllInfo, null, apiHeaders)
            },

            GetParentTags: function (apiHeaders) {
                return BaseApi.get(ApiUrls.Admin.Tags.Activities.GetParentTags, null, apiHeaders)
            }
        }
    },
    
    SubSections: {
        PostUpdate: function (subSectionsDto, apiHeaders) {
            return BaseApi.post(ApiUrls.Admin.SubSections.PostUpdate, subSectionsDto, apiHeaders)
        },

        GetSubSections: function (apiHeaders) {
            return BaseApi.get(ApiUrls.Admin.SubSections.GetSubSections, null, apiHeaders)
        }
    },

    StandardBooks: {
        PostUpdate: function (standardBookDto, apiHeaders) {
            return BaseApi.post(`${ApiUrls.Admin.StandardBooks.PostUpdate}`, standardBookDto, apiHeaders)
        },

        PostDelete: function (standardBookId, apiHeaders) {
            return BaseApi.post(`${ApiUrls.Admin.StandardBooks.PostDelete}?id=${standardBookId}`, null, apiHeaders)
        },

        Get: function (standardBookId, apiHeaders) {
            return BaseApi.get(`${ApiUrls.Admin.StandardBooks.Get}?id=${standardBookId}`, null, apiHeaders)
        },

        GetAll: function (apiHeaders) {
            return BaseApi.get(`${ApiUrls.Admin.StandardBooks.GetAll}`, null, apiHeaders)
        },

        GetAllInfo: function (apiHeaders) {
            return BaseApi.get(ApiUrls.Admin.StandardBooks.GetAllInfo, null, apiHeaders)
        }

    },

    Questions: {
        // GetInfo: function (questionId) {
        //     return BaseApi.get(`${ApiUrls.Admin.Questions.GetInfo}/${questionId}`)
        // },

        // GetActiveQuestions: function () {
        //     return BaseApi.get(`${ApiUrls.Admin.Questions.GetActiveQuestions}`)
        // },

        // GetBranches: function () {
        //     return BaseApi.get(`${ApiUrls.Admin.Questions.GetBranches}`)
        // },

        // GetSubQuestions: function () {
        //     return BaseApi.get(`${ApiUrls.Admin.Questions.GetSubQuestions}`)
        // },
        
        //-------------------- N E W -----------------------
        PostUpdate: function (questionDto, apiHeaders) {
            return BaseApi.post(`${ApiUrls.Admin.Questions.PostUpdate}`, questionDto, apiHeaders)
        },

        PostRemove: function (questionId, apiHeaders) {
            return BaseApi.post(`${ApiUrls.Admin.Questions.PostDelete}?id=${questionId}`, null, apiHeaders)
        },
        Get: function (questionId, apiHeaders) {
            return BaseApi.get(`${ApiUrls.Admin.Questions.Get}?id=${questionId}`, null, apiHeaders)
        },

        GetQuestions: function (apiHeaders) {
            return BaseApi.get(ApiUrls.Admin.Questions.GetQuestions, null, apiHeaders)
        },

        GetAll: function (apiHeaders) {
            return BaseApi.get(ApiUrls.Admin.Questions.GetAll, null, apiHeaders)
        },

        GetAllOptions: function (apiHeaders) {
            return BaseApi.get(ApiUrls.Admin.Questions.GetAllOptions, null, apiHeaders)
        }

    },

    Blocks: {
        PostUpdate: function (blockDto, apiHeaders) {
            return BaseApi.post(`${ApiUrls.Admin.Blocks.PostUpdate}`, blockDto, apiHeaders)
        },

        PostDelete: function (blockId, apiHeaders) {
            return BaseApi.post(`${ApiUrls.Admin.Blocks.PostDelete}?id=${blockId}`, null, apiHeaders)
        },

        PostCopyBlock: function (blockId, apiHeaders) {
            return BaseApi.post(`${ApiUrls.Admin.Blocks.PostCopyBlock}/${blockId}`, null, apiHeaders)
        },

        Get: function (blockId, apiHeaders) {
            return BaseApi.get(`${ApiUrls.Admin.Blocks.Get}?id=${blockId}`, null, apiHeaders)
        },

        GetAll: function (apiHeaders) {
            return BaseApi.get(ApiUrls.Admin.Blocks.GetAll, null, apiHeaders)
        }
    },

    Audits: {
        GetForUser: function (userId) {
            return BaseApi.get(`${ApiUrls.Admin.Audits.GetForUser}/${userId}`)
        },        

        Get: function (auditId) {
            return BaseApi.get(`${ApiUrls.Admin.Audits.Get}/${auditId}`)
        },

        PostResend: function (auditId) {
            return BaseApi.post(`${ApiUrls.Admin.Audits.PostResend}?auditId=${auditId}`)
        },

        GetUsers: function () {
            return BaseApi.get(`${ApiUrls.Admin.Audits.GetUsers}`)
        },

        GetUserAuditInfos: function(userId) {
            return BaseApi.get(`${ApiUrls.Admin.Audits.GetUserAuditInfos}?userId=${userId}`)
        },

        GetUserAuditData: function(userId, auditId) {
            return BaseApi.get(`${ApiUrls.Admin.Audits.GetUserAuditData}?userId=${userId}&auditId=${auditId}`)
        },

        GetAuditDax: function(auditId) {
            return BaseApi.get(`${ApiUrls.Admin.Audits.GetAuditDax}?auditId=${auditId}`)
        },

        OpenClosed: function(userId, auditId) {
            return BaseApi.post(`${ApiUrls.Admin.Audits.OpenClosed}?userId=${userId}&auditId=${auditId}`)
        },

        GetFutureAudits: function() {
            return BaseApi.get(ApiUrls.Admin.Audits.GetFutureAudits)
        },

        ResendAudit: function(auditId) {
            return BaseApi.post(`${ApiUrls.Admin.Audits.ResendAudit}?auditid=${auditId}`)
        },

        GetAuditLink: function(sendDate, auditId){
            return BaseApi.get(`${ApiUrls.Admin.Audits.GetAuditLink}?sendDate=${sendDate}&auditId=${auditId}`)
        }

    },

    Activities: {
        PostUpdate: function (activityDto, apiHeaders) {
            return BaseApi.post(`${ApiUrls.Admin.Activities.PostUpdate}`, activityDto, apiHeaders)
        },

        PostDelete: function (activityId, apiHeaders) {
            return BaseApi.post(`${ApiUrls.Admin.Activities.PostDelete}?id=${activityId}`, null, apiHeaders)
        },

        Get: function (activityId, apiHeaders) {
            return BaseApi.get(`${ApiUrls.Admin.Activities.Get}?id=${activityId}`, null, apiHeaders)
        },

        GetAll: function (apiHeaders) {
            return BaseApi.get(ApiUrls.Admin.Activities.GetAll, null, apiHeaders)
        }

    },

    Branches: {
        PostUpdateSorting: function(branchesDto) {
            return BaseApi.post(ApiUrls.Admin.Branches.PostUpdateSorting, branchesDto)
        },

        Get: function(branchId) {
            return BaseApi.get(`${ApiUrls.Admin.Branches.Get}?id=${branchId}`)
        },

        GetAll: function() {
            return BaseApi.get(ApiUrls.Admin.Branches.GetAll)
        },
        
        GetTerritorialLinks: function () {
            return BaseApi.get(ApiUrls.Admin.Branches.GetTerritorialLinks)
        } 
    },

    Users: {
        PostUpdate: function(userDto) {
            return BaseApi.post(ApiUrls.Admin.Users.PostUpdate, userDto)
        },

        PostSendPush: function(userId, text) {
            return BaseApi.post(`${ApiUrls.Admin.Users.PostSendPush}?userId=${userId}&text=${text}`)
        },

        PostCreate: function(userDto) {
            return BaseApi.post(ApiUrls.Admin.Users.PostCreate, userDto)
        },

        PostDelete: function(userId) {
            return BaseApi.post(`${ApiUrls.Admin.Users.PostDelete}?id=${userId}`)
        },

        Get: function(userId) {
            return BaseApi.get(`${ApiUrls.Admin.Users.Get}?id=${userId}`)
        },

        GetAll: function() {
            return BaseApi.get(ApiUrls.Admin.Users.GetAll)
        },

        GetCheckIsDaxUser: function(phoneNumber) {
            return BaseApi.get(`${ApiUrls.Admin.Users.GetCheckIsDaxUser}?phoneNumber=${phoneNumber}`)
        },

        GetUserRoutes: function(userId) {
            return BaseApi.get(`${ApiUrls.Admin.Users.GetUserRoutes}?userId=${userId}`)
        }
    },

    MobileVersions: {
        PostDelete: function(mobileVersionId) {
            return BaseApi.post(`${ApiUrls.Admin.MobileVersions.PostDelete}?id=${mobileVersionId}`)
        },

        PostDeleteRange: function(mobileVersionIds) {
            return BaseApi.post(ApiUrls.Admin.MobileVersions.PostDeleteRange, mobileVersionIds)
        },

        PostUpdate: function(mobileVersionDto) {
            return BaseApi.post(ApiUrls.Admin.MobileVersions.PostUpdate, mobileVersionDto)
        },

        GetAll: function() {
            return BaseApi.get(ApiUrls.Admin.MobileVersions.GetAll)
        }
    },

    MmlCategories: {
        PostUpdate: function(mmlCategoryDto) {
            return BaseApi.post(ApiUrls.Admin.MmlCategories.PostUpdate, mmlCategoryDto)
        },

        PostDelete: function(mmlCategoryId) {
            return BaseApi.post(`${ApiUrls.Admin.MmlCategories.PostDelete}?id=${mmlCategoryId}`)
        },

        Get: function(mmlCategoryId) {
            return BaseApi.get(`${ApiUrls.Admin.MmlCategories.Get}?id=${mmlCategoryId}`)
        },

        GetAll: function() {
            return BaseApi.get(ApiUrls.Admin.MmlCategories.GetAll)
        }
    },

    TradePoints: {
        PostDelete: function (parentSalesPlaceId) {
            return BaseApi.post(`${ApiUrls.Admin.TradePoints.PostDelete}?parentSalesPlaceId=${parentSalesPlaceId}`)
        },

        PostRestore: function (parentSalesPlaceId) {
            return BaseApi.post(`${ApiUrls.Admin.TradePoints.PostRestore}?parentSalesPlaceId=${parentSalesPlaceId}`)
        },

        GetFind: function (searchText) {
            return BaseApi.get(`${ApiUrls.Admin.TradePoints.GetFind}/${searchText}`)
        },

        GetNetworks: function () {
            return BaseApi.get(ApiUrls.Admin.TradePoints.GetNetworks)
        }

    },

    Tma: {
        GetDaxTtIds: function() {
            return BaseApi.get(ApiUrls.Admin.Tma.GetDaxTtIds)
        },

        GetForDaxTtId: function(daxTtId) {
            return BaseApi.get(`${ApiUrls.Admin.Tma.GetForDaxTtId}?daxTtId=${daxTtId}`)
        }
    },

    TodoCategories: {
        PostUpdateSorting: function(taskCategoriesId) {
            return BaseApi.post(ApiUrls.Admin.TodoCategories.PostUpdateSorting, taskCategoriesId)
        },

        PostDelete: function(taskCategoryId) {
            return BaseApi.post(ApiUrls.Admin.TodoCategories.PostDelete + `?Id=${taskCategoryId}`)
        },

        PostUpdate: function(taskCategoryDto) {
            return BaseApi.post(ApiUrls.Admin.TodoCategories.PostUpdate, taskCategoryDto)
        },

        GetAll: function() {
            return BaseApi.get(ApiUrls.Admin.TodoCategories.GetAll)
        },

        Get: function(taskCategoryId) {
            return BaseApi.get(`${ApiUrls.Admin.TodoCategories.Get}?id=${taskCategoryId}`)
        }
    },

    PhotoCategories: {
        PostUpdate: function(photoCategoryDto) {
            return BaseApi.post(ApiUrls.Admin.PhotoCategories.PostUpdate, photoCategoryDto)
        },

        PostUpdateSorting: function(photoCategoriesId) {
            return BaseApi.post(ApiUrls.Admin.PhotoCategories.PostUpdateSorting, photoCategoriesId)
        },

        PostDelete: function(photoCategoryId) {
            return BaseApi.post(`${ApiUrls.Admin.PhotoCategories.PostDelete}?Id=${photoCategoryId}`)
        },

        Get: function(photoCategoryId) {
            return BaseApi.get(`${ApiUrls.Admin.PhotoCategories.Get}?Id=${photoCategoryId}`)
        },

        GetAll: function () {
            return BaseApi.get(ApiUrls.Admin.PhotoCategories.GetAll)
        }
    },

    Aep: {
        PostDelete: function (aepDto) {
            return BaseApi.post(`${ApiUrls.Admin.Aep.PostDelete}`, aepDto)
        },

        GetTradePointsList: function (tradePointId) {
            return BaseApi.get(`${ApiUrls.Admin.Aep.GetTradePointsList}/${tradePointId}`)
        },

    },

    ToDos: {
        PostDelete: function (contactId) {
            return BaseApi.post(`${ApiUrls.Admin.ToDos.PostDelete}?Id=${contactId}`)
        },

        PostRestore: function (contactId) {
            return BaseApi.post(`${ApiUrls.Admin.ToDos.PostRestore}?Id=${contactId}`)
        },

        GetSearch: function (searchText) {
            return BaseApi.get(`${ApiUrls.Admin.ToDos.GetSearch}/${searchText}`)
        },

    },

    Routes: {
        GetIndexInfo: function () {
            return BaseApi.get(`${ApiUrls.Admin.Routes.GetIndexInfo}`)
        },

        GetUsersRoutes: function (userId) {
            return BaseApi.get(`${ApiUrls.Admin.Routes.GetUsersRoutes}?userId=${userId}`)
        },

        Get: function (userId, routeDate) {
            return BaseApi.get(`${ApiUrls.Admin.Routes.Get}?userId=${userId}&routeDate=${routeDate}`)
        },

    },

    Contacts: {
        PostDelete: function (contactId) {
            return BaseApi.post(`${ApiUrls.Admin.Contacts.PostDelete}?Id=${contactId}`)
        },

        PostRestore: function (contactId) {
            return BaseApi.post(`${ApiUrls.Admin.Contacts.PostRestore}?Id=${contactId}`)
        },

        GetSearch: function (searchText) {
            return BaseApi.get(`${ApiUrls.Admin.Contacts.GetSearch}/${searchText}`)
        },

    },

    MagnitAlerts: {
        GetForTradePoints: function (date) {
            return BaseApi.get(`${ApiUrls.Admin.MagnitAlerts.GetForTradePoints}?date=${date}`)
        }
    },

    Cache: {

        ResetActivities: function (apiHeaders) {
            return BaseApi.post(ApiUrls.Admin.Cache.PostActivitiesResetCache, null, apiHeaders);
        },

        ResetPhotoCategories: function() {
            return BaseApi.post(ApiUrls.Admin.Cache.PostPhotosResetCache);
        },

        ResetStandartsBooks: function() {
            return BaseApi.post(ApiUrls.Admin.Cache.PostStandartsBookResetCache);
        },

        ResetTodoCategories: function() {
            return BaseApi.post(ApiUrls.Admin.Cache.PostTodoCategoriesResetCache);
        }
    },

    Bot: {
        Filters: {
            GetAll: function() {
              return BaseApi.get(ApiUrls.Admin.Bot.Filters.GetAll);
            },
          
            Get: function(id) {
                return BaseApi.get(`${ApiUrls.Admin.Bot.Filters.Get}?id=${id}`);
            },
          
            PostCreateOrUpdate: function(body) {
                return BaseApi.post(ApiUrls.Admin.Bot.Filters.PostCreateOrUpdate, body);
            },
          
            Delete: function(id) {
                return BaseApi.delete(`${ApiUrls.Admin.Bot.Filters.Delete}?id=${id}`);
            },

            GetFormsLinks: function() {
                return BaseApi.get(ApiUrls.Admin.Bot.Filters.GetFormsLinks);
            }
        }
    }

}

